import { useState } from 'react';
import { championshipsApi, matchesApi } from '../../../lib/api';
import { toast } from 'sonner';

const MATCHES_PAGE_SIZE = 500;

export const useMatchesActions = ({ isItalian }) => {
  const [matches, setMatches] = useState([]);
  const [matchesTotal, setMatchesTotal] = useState(0);
  const [selectedChampForMatches, setSelectedChampForMatches] = useState(null);
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [loadingMoreMatches, setLoadingMoreMatches] = useState(false);
  const [editingMatch, setEditingMatch] = useState(null);
  const [matchDateInput, setMatchDateInput] = useState('');

  const fetchMatchesForChampionship = async (championshipId, append = false, loadAll = false) => {
    if (append) { setLoadingMoreMatches(true); } else { setLoadingMatches(true); setMatches([]); setMatchesTotal(0); }
    try {
      const skip = append ? matches.length : 0;
      const limit = loadAll ? 0 : MATCHES_PAGE_SIZE; // 0 = no limit server-side
      const res = await championshipsApi.getFixtures(championshipId, null, { skip, limit });
      const data = res.data;
      if (data.matches) {
        if (append) { setMatches(prev => [...prev, ...data.matches]); } else { setMatches(data.matches); }
        setMatchesTotal(data.total);
      } else {
        setMatches(Array.isArray(data) ? data : []);
        setMatchesTotal(Array.isArray(data) ? data.length : 0);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || (isItalian ? 'Errore caricamento partite' : 'Error loading matches'));
    } finally { setLoadingMatches(false); setLoadingMoreMatches(false); }
  };

  const handleUpdateMatchDate = async (matchId) => {
    try {
      await matchesApi.updateDate(matchId, matchDateInput || null);
      toast.success(isItalian ? 'Data partita aggiornata!' : 'Match date updated!');
      setEditingMatch(null); setMatchDateInput('');
      if (selectedChampForMatches) fetchMatchesForChampionship(selectedChampForMatches);
    } catch (error) {
      toast.error(error.response?.data?.detail || (isItalian ? 'Errore aggiornamento data' : 'Error updating date'));
    }
  };

  const handleCancelMatchReport = async (matchId) => {
    if (!window.confirm(isItalian ? 'Sei sicuro di voler annullare questo report? La partita tornerà nello stato "scheduled".' : 'Are you sure you want to cancel this report? The match will revert to "scheduled".')) return;
    try {
      await matchesApi.cancelReport(matchId);
      toast.success(isItalian ? 'Report annullato! La partita è tornata nello stato "scheduled".' : 'Report cancelled! Match reverted to "scheduled".');
      if (selectedChampForMatches) fetchMatchesForChampionship(selectedChampForMatches);
    } catch (error) {
      toast.error(error.response?.data?.detail || (isItalian ? 'Errore annullamento report' : 'Error cancelling report'));
    }
  };

  return {
    matches, matchesTotal, selectedChampForMatches, setSelectedChampForMatches,
    fetchMatchesForChampionship, setMatches,
    loadingMatches, loadingMoreMatches,
    editingMatch, setEditingMatch,
    matchDateInput, setMatchDateInput,
    handleUpdateMatchDate, handleCancelMatchReport,
    MATCHES_PAGE_SIZE,
  };
};
